import { create } from "zustand";
import { loadBooks, saveBooks } from "../utils/storage";

// initial sample data if storage is empty
const defaultBooks = [
  {
    id: "1",
    title: "The Pragmatic Programmer",
    author: "Andy Hunt, Dave Thomas",
    status: "reading",
    rating: 5,
    genres: ["engineering", "craft"],
    createdAt: Date.now() - 1000 * 60 * 60 * 24 * 5,
  },
  {
    id: "2",
    title: "Atomic Habits",
    author: "James Clear",
    status: "finished",
    rating: 4,
    genres: ["self-improvement", "productivity"],
    createdAt: Date.now() - 1000 * 60 * 60 * 24 * 10,
  },
  {
    id: "3",
    title: "Clean Code",
    author: "Robert C. Martin",
    status: "tbr",
    rating: 0,
    genres: ["engineering", "best-practices"],
    createdAt: Date.now() - 1000 * 60 * 60 * 24 * 30,
  },
];

export const useBooksStore = create((set, get) => ({
  books: loadBooks() ?? defaultBooks,

  addBook: (bookData) => {
    const newBook = {
      id: crypto.randomUUID(),
      title: bookData.title || "Untitled",
      author: bookData.author || "Unknown",
      status: bookData.status || "tbr",
      rating: Number(bookData.rating || 0),
      genres: bookData.genres || [],
      createdAt: Date.now(),
    };

    const updated = [newBook, ...get().books];
    saveBooks(updated);
    set({ books: updated });
  },

  updateBook: (id, patch) => {
    const updated = get().books.map((b) =>
      b.id === id
        ? {
            ...b,
            ...patch,
            rating: patch.rating !== undefined ? Number(patch.rating) : b.rating,
          }
        : b
    );
    saveBooks(updated);
    set({ books: updated });
  },

  removeBook: (id) => {
    const updated = get().books.filter((b) => b.id !== id);
    saveBooks(updated);
    set({ books: updated });
  },

  getBookById: (id) => {
    return get().books.find((b) => b.id === id);
  },
}));
